import { all, put, SagaIterator, takeEveryCompletedRequest, takeEveryErrorRequest } from './core/sagaEffects';
import { AddNotification, FetchRequest } from 'acscp/actions';
import { AcceptAccountLinkRequest } from 'acscp/api/requests/acceptAccountLink';
import { BookingsRequest } from 'acscp/api/requests';
import { NotificationType } from 'acscp/store/notificationState';
import { defineMessages } from 'react-intl';
import history from 'acscp/store/history';
import { ResponseErrorTypes, ResponseType } from 'acscp/api/responses';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import { getTranslatableErrorMessage } from 'acscp/components/common/helpers/getTranslatableErrorMessage';
import { home } from 'acscp/components/routeHelper';

const translations = defineMessages({
    acceptedAccountLink: {
        id: 'sagas.acceptAccountLinkSaga.acceptedAccountLink',
        defaultMessage: 'Account link created'
    },
});

export function* acceptAccountLinkSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(AcceptAccountLinkRequest, handleAcceptAccountLinkSuccess),
        takeEveryErrorRequest(AcceptAccountLinkRequest, handleAcceptAccountLinkErrors)
    ]);
}

export function* handleAcceptAccountLinkSuccess(): SagaIterator {
    yield put(new AddNotification('acceptAccountLinkSuccess', translations.acceptedAccountLink, NotificationType.Info));
    yield put(new FetchRequest(new BookingsRequest()));
}

export function* handleAcceptAccountLinkErrors(
    responseType: ResponseErrorTypes,
    error: ErrorDetails,
    request: AcceptAccountLinkRequest
): SagaIterator {
    if (responseType !== ResponseType.Unauthorized) {
        yield put(new AddNotification('acceptAccountLinkFailure', getTranslatableErrorMessage(error.message), NotificationType.Error));
        history.push(home()); // don't use the not found page
    }
}
